import React, { useState } from "react";
import FormGroup from "@liveramp/motif/core/FormGroup";
import FormControlLabel from "@liveramp/motif/core/FormControlLabel";
import Switch from "@liveramp/motif/core/Switch";

export default function SizeDemo() {
  let [medium, setMedium] = useState(true);
  let [small, setSmall] = useState(true);

  return (
    <FormGroup>
      <FormControlLabel
        control={
          <Switch
            checked={medium}
            onChange={() => setMedium(!medium)}
            value="medium"
          />
        }
        label="Medium"
      />
      <FormControlLabel
        control={
          <Switch
            checked={small}
            onChange={() => setSmall(!small)}
            size="small"
            value="size"
          />
        }
        size="small"
        label="Small"
      />
    </FormGroup>
  );
}
